import React, { memo } from 'react';
import { Checkbox, Empty, Menu, Radio } from 'antd';
import cn from 'classnames';
import { btnTypes } from '../../../../../../../../components/btn';
import FetchError from '../../../../../../../../components/FetchError';
import ActionBtn from '../ActionBtn';
import styles from './index.module.scss';

const MemoizedActions = memo(Actions);
const MemoizedItem = memo(Item);

const Overlay = ({
  value,
  items,
  multiple,
  errorMessage,
  refetch,
  onItemClick,
  onOk,
  onReset,
  className,
  ...props
}) => {
  const hasFetchError = Boolean(errorMessage);
  const hasItems = items.length > 0;

  const showEmpty = !hasFetchError && !hasItems;
  const showMainContent = !hasFetchError && hasItems;

  return (
    <Menu
      {...props}
      onClick={undefined}
      className={cn(styles.overlay, className)}
    >
      {hasFetchError && (
        <Menu.Item className={styles.notInteractive}>
          <FetchError text={errorMessage} refetch={refetch} />
        </Menu.Item>
      )}

      {showEmpty && (
        <Menu.Item className={styles.notInteractive}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Нет данных"
          />
        </Menu.Item>
      )}

      {showMainContent &&
        items.map((item) => {
          return (
            <MemoizedItem
              key={item.value}
              value={item.value}
              content={`${item.content} (${item.count || 0})`}
              onItemClick={onItemClick}
              checker={multiple ? Checkbox : Radio}
              selected={
                multiple && Array.isArray(value)
                  ? value.includes(item.value)
                  : value === item.value
              }
            />
          );
        })}
      {showMainContent && <MemoizedActions onOk={onOk} onReset={onReset} />}
    </Menu>
  );
};

export default Overlay;

function Actions({ onOk, onReset, className, ...props }) {
  return (
    <Menu.Item
      {...props}
      className={cn(styles.overlayActions, styles.notInteractive, className)}
    >
      <ActionBtn type={btnTypes.primary} onClick={onOk}>
        Применить
      </ActionBtn>
      <ActionBtn type={btnTypes.secondary} onClick={onReset}>
        Сбросить
      </ActionBtn>
    </Menu.Item>
  );
}

function Item({
  content,
  value,
  checker: Checker,
  onItemClick,
  selected,
  className,
  ...props
}) {
  const handleClick = () => {
    onItemClick(value, !selected);
  };

  return (
    <Menu.Item
      {...props}
      className={cn(styles.overlayItem, className)}
      onClick={handleClick}
    >
      <Checker checked={selected} />
      {content}
    </Menu.Item>
  );
}
